import CardProject from '../../components/items/CardProject'

import bakery from '../../img/projects/bakery.png'
import react from '../../img/technology/react.png'
import html from '../../img/technology/html.png'
import css from '../../img/technology/css.png'
import javaScript from '../../img/technology/javascript.png'

export default function Project9() {
  return (
    <div>
      <CardProject
        name="Bakery"
        img={bakery}
        text="O projeto Bakery é uma landing page desenvolvida com foco em uma experiência de usuário moderna e visualmente atraente, utilizando as melhores práticas de desenvolvimento web. A aplicação foi construída com React, garantindo uma interface dinâmica e responsiva, em conjunto com styled-components para estilização, oferecendo um design sofisticado e customizado. O objetivo principal da Bakery é criar uma plataforma interativa e visualmente impactante para uma padaria, destacando seus produtos e serviços de maneira intuitiva e acessível. A aplicação integra ícones modernos por meio da biblioteca react-icons e utiliza o react-scroll para proporcionar uma navegação suave entre as seções da página, otimizando a usabilidade e a fluidez da experiência. Uma funcionalidade adicional importante é o sistema de notificações personalizadas utilizando a biblioteca sonner, que oferece feedback instantâneo e amigável para os usuários, como ao enviar mensagens de contato. O projeto foi desenvolvido utilizando Vite para uma experiência de desenvolvimento rápida e eficiente, além de boas práticas de código com suporte a TypeScript e ESLint, garantindo maior segurança e qualidade no desenvolvimento."
        app="https://bakery-ten-eta.vercel.app/"
        repo="https://github.com/RiccettoDev/bakery"
        technology1={react}
        nameTechnology1="React JS"
        technology2={html}
        nameTechnology2="HTML"
        technology3={css}
        nameTechnology3="CSS"
        technology4={javaScript}
        nameTechnology4="JavaScript"
      />
    </div>
  )
}
